import { createClient, type SanityClient } from 'next-sanity'

const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET

// Only create client if configuration is available
export const client: SanityClient | null = projectId && dataset
  ? createClient({
      projectId,
      dataset,
      apiVersion: '2024-12-01',
      useCdn: false,
    })
  : null

export function isSanityConfigured(): boolean {
  return client !== null
}
